[
  {
    "sourceQuestionId": "3",
    "key": "people.doctorName",
    "label": "Doctors Name",
    "stage": 1,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "4",
    "key": "locations.addressLine1",
    "label": "Practice Address — Street Address",
    "stage": 0,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "4",
    "key": "locations.addressLine2",
    "label": "Practice Address — Street Address Line 2",
    "stage": 0,
    "kind": "text",
    "required": false,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "4",
    "key": "locations.city",
    "label": "Practice Address — City",
    "stage": 0,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "4",
    "key": "locations.region",
    "label": "Practice Address — State / Province",
    "stage": 0,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "4",
    "key": "locations.postalCode",
    "label": "Practice Address — Postal / Zip Code",
    "stage": 0,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "4",
    "key": "locations.countryCode",
    "label": "Practice Address — Country",
    "stage": 0,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "5",
    "key": "people.officePhone",
    "label": "Office Number",
    "stage": 1,
    "kind": "tel",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "6",
    "key": "people.contactEmail",
    "label": "E-mail",
    "stage": 1,
    "kind": "email",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "8",
    "key": "business.entityType",
    "label": "Type of Entity",
    "stage": 3,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "Individual/Sole Proprietor",
      "C-Corp",
      "S-Corp",
      "LLC",
      "Trust Estate"
    ]
  },
  {
    "sourceQuestionId": "33",
    "key": "business.legalName",
    "label": "Legal Business Name",
    "stage": 0,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "34",
    "key": "people.mobilePhone",
    "label": "Mobile Number",
    "stage": 1,
    "kind": "tel",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "36",
    "key": "people.mainContactName",
    "label": "Main Practice Contact Name",
    "stage": 1,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "37",
    "key": "people.mainContactEmail",
    "label": "Main Practice Contact Email",
    "stage": 1,
    "kind": "email",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "38",
    "key": "locations.reportedLocationCount",
    "label": "Number of Practice Locations",
    "stage": 0,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "39",
    "key": "business.practiceType",
    "label": "Type of Practice",
    "stage": 0,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "General Dentist",
      "Endodontist",
      "Oral Surgeon",
      "Orthodontist",
      "Pediatric",
      "Prosthodontist",
      "Multi-Specialty Practice"
    ]
  },
  {
    "sourceQuestionId": "42",
    "key": "operations.monthlyPatientVisits",
    "label": "Approximately how many patient visits does your practice see per month?",
    "stage": 2,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "Under 300",
      "300–600",
      "600–900",
      "900–1,200",
      "1,200+"
    ]
  },
  {
    "sourceQuestionId": "84",
    "key": "interests.programInterest",
    "label": "Let us know what parts of the program you are interested in.",
    "stage": 3,
    "kind": "multi",
    "required": false,
    "hidden": true,
    "options": [
      "Becoming a cancer screening center",
      "The employee benefits program",
      "Recombinant - Tax saving program",
      "Exclusive ChairShare Membership",
      "All of the above."
    ]
  },
  {
    "sourceQuestionId": "85",
    "key": "people.totalEmployeeCount",
    "label": "How many total employees do you have?",
    "stage": 2,
    "kind": "number",
    "required": false,
    "hidden": true,
    "options": []
  },
  {
    "sourceQuestionId": "88",
    "key": "people.fullTimeEmployeeCount",
    "label": "Number of Full-Time Employees (28+hrs/week)",
    "stage": 2,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48",
      "49",
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "56",
      "57",
      "58",
      "59",
      "60",
      "61",
      "62",
      "63",
      "64",
      "65",
      "66",
      "67",
      "68",
      "69",
      "70",
      "71",
      "72",
      "73",
      "74",
      "75",
      "76",
      "77",
      "78",
      "79",
      "80",
      "81",
      "82",
      "83",
      "84",
      "85",
      "86",
      "87",
      "88",
      "89",
      "90",
      "91",
      "92",
      "93",
      "94",
      "95",
      "96",
      "97",
      "98",
      "99",
      "100",
      "101",
      "102",
      "103",
      "104",
      "105",
      "106",
      "107",
      "108",
      "109",
      "110",
      "111",
      "112",
      "113",
      "114",
      "115",
      "116",
      "117",
      "118",
      "119",
      "120",
      "121",
      "122",
      "123",
      "124",
      "125",
      "126",
      "127",
      "128",
      "129",
      "130",
      "131",
      "132",
      "133",
      "134",
      "135",
      "136",
      "137",
      "138",
      "139",
      "140",
      "141",
      "142",
      "143",
      "144",
      "145",
      "146",
      "147",
      "148",
      "149",
      "150",
      "151",
      "152",
      "153",
      "154",
      "155",
      "156",
      "157",
      "158",
      "159",
      "160",
      "161",
      "162",
      "163",
      "164",
      "165",
      "166",
      "167",
      "168",
      "169",
      "170",
      "171",
      "172",
      "173",
      "174",
      "175",
      "176",
      "177",
      "178",
      "179",
      "180",
      "181",
      "182",
      "183",
      "184",
      "185",
      "186",
      "187",
      "188",
      "189",
      "190",
      "191",
      "192",
      "193",
      "194",
      "195",
      "196",
      "197",
      "198",
      "199",
      "200",
      "201",
      "202",
      "203",
      "204",
      "205",
      "206",
      "207",
      "208",
      "209",
      "210",
      "211",
      "212",
      "213",
      "214",
      "215",
      "216",
      "217",
      "218",
      "219",
      "220",
      "221",
      "222",
      "223",
      "224",
      "225",
      "226",
      "227",
      "228",
      "229",
      "230",
      "231",
      "232",
      "233",
      "234",
      "235",
      "236",
      "237",
      "238",
      "239",
      "240",
      "241",
      "242",
      "243",
      "244",
      "245",
      "246",
      "247",
      "248",
      "249",
      "250",
      "251",
      "252",
      "253",
      "254",
      "255",
      "256",
      "257",
      "258",
      "259",
      "260",
      "261",
      "262",
      "263",
      "264",
      "265",
      "266",
      "267",
      "268",
      "269",
      "270",
      "271",
      "272",
      "273",
      "274",
      "275",
      "276",
      "277",
      "278",
      "279",
      "280",
      "281",
      "282",
      "283",
      "284",
      "285",
      "286",
      "287",
      "288",
      "289",
      "290",
      "291",
      "292",
      "293",
      "294",
      "295",
      "296",
      "297",
      "298",
      "299",
      "300",
      "301",
      "302",
      "303",
      "304",
      "305",
      "306",
      "307",
      "308",
      "309",
      "310",
      "311",
      "312",
      "313",
      "314",
      "315",
      "316",
      "317",
      "318",
      "319",
      "320",
      "321",
      "322",
      "323",
      "324",
      "325",
      "326",
      "327",
      "328",
      "329",
      "330",
      "331",
      "332",
      "333",
      "334",
      "335",
      "336",
      "337",
      "338",
      "339",
      "340",
      "341",
      "342",
      "343",
      "344",
      "345",
      "346",
      "347",
      "348",
      "349",
      "350",
      "351",
      "352",
      "353",
      "354",
      "355",
      "356",
      "357",
      "358",
      "359",
      "360",
      "361",
      "362",
      "363",
      "364",
      "365",
      "366",
      "367",
      "368",
      "369",
      "370",
      "371",
      "372",
      "373",
      "374",
      "375",
      "376",
      "377",
      "378",
      "379",
      "380",
      "381",
      "382",
      "383",
      "384",
      "385",
      "386",
      "387",
      "388",
      "389",
      "390",
      "391",
      "392",
      "393",
      "394",
      "395",
      "396",
      "397",
      "398",
      "399",
      "400",
      "401",
      "402",
      "403",
      "404",
      "405",
      "406",
      "407",
      "408",
      "409",
      "410",
      "411",
      "412",
      "413",
      "414",
      "415",
      "416",
      "417",
      "418",
      "419",
      "420",
      "421",
      "422",
      "423",
      "424",
      "425",
      "426",
      "427",
      "428",
      "429",
      "430",
      "431",
      "432",
      "433",
      "434",
      "435",
      "436",
      "437",
      "438",
      "439",
      "440",
      "441",
      "442",
      "443",
      "444",
      "445",
      "446",
      "447",
      "448",
      "449",
      "450",
      "451",
      "452",
      "453",
      "454",
      "455",
      "456",
      "457",
      "458",
      "459",
      "460",
      "461",
      "462",
      "463",
      "464",
      "465",
      "466",
      "467",
      "468",
      "469",
      "470",
      "471",
      "472",
      "473",
      "474",
      "475",
      "476",
      "477",
      "478",
      "479",
      "480",
      "481",
      "482",
      "483",
      "484",
      "485",
      "486",
      "487",
      "488",
      "489",
      "490",
      "491",
      "492",
      "493",
      "494",
      "495",
      "496",
      "497",
      "498",
      "499",
      "500",
      "501",
      "502",
      "503",
      "504",
      "505",
      "506",
      "507",
      "508",
      "509",
      "510",
      "511",
      "512",
      "513",
      "514",
      "515",
      "516",
      "517",
      "518",
      "519",
      "520",
      "521",
      "522",
      "523",
      "524",
      "525",
      "526",
      "527",
      "528",
      "529",
      "530",
      "531",
      "532",
      "533",
      "534",
      "535",
      "536",
      "537",
      "538",
      "539",
      "540",
      "541",
      "542",
      "543",
      "544",
      "545",
      "546",
      "547",
      "548",
      "549",
      "550",
      "551",
      "552",
      "553",
      "554",
      "555",
      "556",
      "557",
      "558",
      "559",
      "560",
      "561",
      "562",
      "563",
      "564",
      "565",
      "566",
      "567",
      "568",
      "569",
      "570",
      "571",
      "572",
      "573",
      "574",
      "575",
      "576",
      "577",
      "578",
      "579",
      "580",
      "581",
      "582",
      "583",
      "584",
      "585",
      "586",
      "587",
      "588",
      "589",
      "590",
      "591",
      "592",
      "593",
      "594",
      "595",
      "596",
      "597",
      "598",
      "599",
      "600",
      "601",
      "602",
      "603",
      "604",
      "605",
      "606",
      "607",
      "608",
      "609",
      "610",
      "611",
      "612",
      "613",
      "614",
      "615",
      "616",
      "617",
      "618",
      "619",
      "620",
      "621",
      "622",
      "623",
      "624",
      "625",
      "626",
      "627",
      "628",
      "629",
      "630",
      "631",
      "632",
      "633",
      "634",
      "635",
      "636",
      "637",
      "638",
      "639",
      "640",
      "641",
      "642",
      "643",
      "644",
      "645",
      "646",
      "647",
      "648",
      "649",
      "650",
      "651",
      "652",
      "653",
      "654",
      "655",
      "656",
      "657",
      "658",
      "659",
      "660",
      "661",
      "662",
      "663",
      "664",
      "665",
      "666",
      "667",
      "668",
      "669",
      "670",
      "671",
      "672",
      "673",
      "674",
      "675",
      "676",
      "677",
      "678",
      "679",
      "680",
      "681",
      "682",
      "683",
      "684",
      "685",
      "686",
      "687",
      "688",
      "689",
      "690",
      "691",
      "692",
      "693",
      "694",
      "695",
      "696",
      "697",
      "698",
      "699",
      "700",
      "701",
      "702",
      "703",
      "704",
      "705",
      "706",
      "707",
      "708",
      "709",
      "710",
      "711",
      "712",
      "713",
      "714",
      "715",
      "716",
      "717",
      "718",
      "719",
      "720",
      "721",
      "722",
      "723",
      "724",
      "725",
      "726",
      "727",
      "728",
      "729",
      "730",
      "731",
      "732",
      "733",
      "734",
      "735",
      "736",
      "737",
      "738",
      "739",
      "740",
      "741",
      "742",
      "743",
      "744",
      "745",
      "746",
      "747",
      "748",
      "749",
      "750",
      "751",
      "752",
      "753",
      "754",
      "755",
      "756",
      "757",
      "758",
      "759",
      "760",
      "761",
      "762",
      "763",
      "764",
      "765",
      "766",
      "767",
      "768",
      "769",
      "770",
      "771",
      "772",
      "773",
      "774",
      "775",
      "776",
      "777",
      "778",
      "779",
      "780",
      "781",
      "782",
      "783",
      "784",
      "785",
      "786",
      "787",
      "788",
      "789",
      "790",
      "791",
      "792",
      "793",
      "794",
      "795",
      "796",
      "797",
      "798",
      "799",
      "800",
      "801",
      "802",
      "803",
      "804",
      "805",
      "806",
      "807",
      "808",
      "809",
      "810",
      "811",
      "812",
      "813",
      "814",
      "815",
      "816",
      "817",
      "818",
      "819",
      "820",
      "821",
      "822",
      "823",
      "824",
      "825",
      "826",
      "827",
      "828",
      "829",
      "830",
      "831",
      "832",
      "833",
      "834",
      "835",
      "836",
      "837",
      "838",
      "839",
      "840",
      "841",
      "842",
      "843",
      "844",
      "845",
      "846",
      "847",
      "848",
      "849",
      "850",
      "851",
      "852",
      "853",
      "854",
      "855",
      "856",
      "857",
      "858",
      "859",
      "860",
      "861",
      "862",
      "863",
      "864",
      "865",
      "866",
      "867",
      "868",
      "869",
      "870",
      "871",
      "872",
      "873",
      "874",
      "875",
      "876",
      "877",
      "878",
      "879",
      "880",
      "881",
      "882",
      "883",
      "884",
      "885",
      "886",
      "887",
      "888",
      "889",
      "890",
      "891",
      "892",
      "893",
      "894",
      "895",
      "896",
      "897",
      "898",
      "899",
      "900",
      "901",
      "902",
      "903",
      "904",
      "905",
      "906",
      "907",
      "908",
      "909",
      "910",
      "911",
      "912",
      "913",
      "914",
      "915",
      "916",
      "917",
      "918",
      "919",
      "920",
      "921",
      "922",
      "923",
      "924",
      "925",
      "926",
      "927",
      "928",
      "929",
      "930",
      "931",
      "932",
      "933",
      "934",
      "935",
      "936",
      "937",
      "938",
      "939",
      "940",
      "941",
      "942",
      "943",
      "944",
      "945",
      "946",
      "947",
      "948",
      "949",
      "950",
      "951",
      "952",
      "953",
      "954",
      "955",
      "956",
      "957",
      "958",
      "959",
      "960",
      "961",
      "962",
      "963",
      "964",
      "965",
      "966",
      "967",
      "968",
      "969",
      "970",
      "971",
      "972",
      "973",
      "974",
      "975",
      "976",
      "977",
      "978",
      "979",
      "980",
      "981",
      "982",
      "983",
      "984",
      "985",
      "986",
      "987",
      "988",
      "989",
      "990",
      "991",
      "992",
      "993",
      "994",
      "995",
      "996",
      "997",
      "998",
      "999",
      "1000",
      "1001",
      "1002",
      "1003",
      "1004",
      "1005",
      "1006",
      "1007",
      "1008",
      "1009",
      "1010",
      "1011",
      "1012",
      "1013",
      "1014",
      "1015",
      "1016",
      "1017",
      "1018",
      "1019",
      "1020",
      "1021",
      "1022",
      "1023",
      "1024",
      "1025",
      "1026",
      "1027",
      "1028",
      "1029",
      "1030",
      "1031",
      "1032",
      "1033",
      "1034",
      "1035",
      "1036",
      "1037",
      "1038",
      "1039",
      "1040",
      "1041",
      "1042",
      "1043",
      "1044",
      "1045",
      "1046",
      "1047",
      "1048",
      "1049",
      "1050",
      "1051",
      "1052",
      "1053",
      "1054",
      "1055",
      "1056",
      "1057",
      "1058",
      "1059",
      "1060",
      "1061",
      "1062",
      "1063",
      "1064",
      "1065",
      "1066",
      "1067",
      "1068",
      "1069",
      "1070",
      "1071",
      "1072",
      "1073",
      "1074",
      "1075",
      "1076",
      "1077",
      "1078",
      "1079",
      "1080",
      "1081",
      "1082",
      "1083",
      "1084",
      "1085",
      "1086",
      "1087",
      "1088",
      "1089",
      "1090",
      "1091",
      "1092",
      "1093",
      "1094",
      "1095",
      "1096",
      "1097",
      "1098",
      "1099",
      "1100",
      "1101",
      "1102",
      "1103",
      "1104",
      "1105",
      "1106",
      "1107",
      "1108",
      "1109",
      "1110",
      "1111",
      "1112",
      "1113",
      "1114",
      "1115",
      "1116",
      "1117",
      "1118",
      "1119",
      "1120",
      "1121",
      "1122",
      "1123",
      "1124",
      "1125",
      "1126",
      "1127",
      "1128",
      "1129",
      "1130",
      "1131",
      "1132",
      "1133",
      "1134",
      "1135",
      "1136",
      "1137",
      "1138",
      "1139",
      "1140",
      "1141",
      "1142",
      "1143",
      "1144",
      "1145",
      "1146",
      "1147",
      "1148",
      "1149",
      "1150",
      "1151",
      "1152",
      "1153",
      "1154",
      "1155",
      "1156",
      "1157",
      "1158",
      "1159",
      "1160",
      "1161",
      "1162",
      "1163",
      "1164",
      "1165",
      "1166",
      "1167",
      "1168",
      "1169",
      "1170",
      "1171",
      "1172",
      "1173",
      "1174",
      "1175",
      "1176",
      "1177",
      "1178",
      "1179",
      "1180",
      "1181",
      "1182",
      "1183",
      "1184",
      "1185",
      "1186",
      "1187",
      "1188",
      "1189",
      "1190",
      "1191",
      "1192",
      "1193",
      "1194",
      "1195",
      "1196",
      "1197",
      "1198",
      "1199",
      "1200",
      "1201",
      "1202",
      "1203",
      "1204",
      "1205",
      "1206",
      "1207",
      "1208",
      "1209",
      "1210",
      "1211",
      "1212",
      "1213",
      "1214",
      "1215",
      "1216",
      "1217",
      "1218",
      "1219",
      "1220",
      "1221",
      "1222",
      "1223",
      "1224",
      "1225",
      "1226",
      "1227",
      "1228",
      "1229",
      "1230",
      "1231",
      "1232",
      "1233",
      "1234",
      "1235",
      "1236",
      "1237",
      "1238",
      "1239",
      "1240",
      "1241",
      "1242",
      "1243",
      "1244",
      "1245",
      "1246",
      "1247",
      "1248",
      "1249",
      "1250",
      "1251",
      "1252",
      "1253",
      "1254",
      "1255",
      "1256",
      "1257",
      "1258",
      "1259",
      "1260",
      "1261",
      "1262",
      "1263",
      "1264",
      "1265",
      "1266",
      "1267",
      "1268",
      "1269",
      "1270",
      "1271",
      "1272",
      "1273",
      "1274",
      "1275",
      "1276",
      "1277",
      "1278",
      "1279",
      "1280",
      "1281",
      "1282",
      "1283",
      "1284",
      "1285",
      "1286",
      "1287",
      "1288",
      "1289",
      "1290",
      "1291",
      "1292",
      "1293",
      "1294",
      "1295",
      "1296",
      "1297",
      "1298",
      "1299",
      "1300",
      "1301",
      "1302",
      "1303",
      "1304",
      "1305",
      "1306",
      "1307",
      "1308",
      "1309",
      "1310",
      "1311",
      "1312",
      "1313",
      "1314",
      "1315",
      "1316",
      "1317",
      "1318",
      "1319",
      "1320",
      "1321",
      "1322",
      "1323",
      "1324",
      "1325",
      "1326",
      "1327",
      "1328",
      "1329",
      "1330",
      "1331",
      "1332",
      "1333",
      "1334",
      "1335",
      "1336",
      "1337",
      "1338",
      "1339",
      "1340",
      "1341",
      "1342",
      "1343",
      "1344",
      "1345",
      "1346",
      "1347",
      "1348",
      "1349",
      "1350",
      "1351",
      "1352",
      "1353",
      "1354",
      "1355",
      "1356",
      "1357",
      "1358",
      "1359",
      "1360",
      "1361",
      "1362",
      "1363",
      "1364",
      "1365",
      "1366",
      "1367",
      "1368",
      "1369",
      "1370",
      "1371",
      "1372",
      "1373",
      "1374",
      "1375",
      "1376",
      "1377",
      "1378",
      "1379",
      "1380",
      "1381",
      "1382",
      "1383",
      "1384",
      "1385",
      "1386",
      "1387",
      "1388",
      "1389",
      "1390",
      "1391",
      "1392",
      "1393",
      "1394",
      "1395",
      "1396",
      "1397",
      "1398",
      "1399",
      "1400",
      "1401",
      "1402",
      "1403",
      "1404",
      "1405",
      "1406",
      "1407",
      "1408",
      "1409",
      "1410",
      "1411",
      "1412",
      "1413",
      "1414",
      "1415",
      "1416",
      "1417",
      "1418",
      "1419",
      "1420",
      "1421",
      "1422",
      "1423",
      "1424",
      "1425",
      "1426",
      "1427",
      "1428",
      "1429",
      "1430",
      "1431",
      "1432",
      "1433",
      "1434",
      "1435",
      "1436",
      "1437",
      "1438",
      "1439",
      "1440",
      "1441",
      "1442",
      "1443",
      "1444",
      "1445",
      "1446",
      "1447",
      "1448",
      "1449",
      "1450",
      "1451",
      "1452",
      "1453",
      "1454",
      "1455",
      "1456",
      "1457",
      "1458",
      "1459",
      "1460",
      "1461",
      "1462",
      "1463",
      "1464",
      "1465",
      "1466",
      "1467",
      "1468",
      "1469",
      "1470",
      "1471",
      "1472",
      "1473",
      "1474",
      "1475",
      "1476",
      "1477",
      "1478",
      "1479",
      "1480",
      "1481",
      "1482",
      "1483",
      "1484",
      "1485",
      "1486",
      "1487",
      "1488",
      "1489",
      "1490",
      "1491",
      "1492",
      "1493",
      "1494",
      "1495",
      "1496",
      "1497",
      "1498",
      "1499",
      "1500",
      "1501",
      "1502",
      "1503",
      "1504",
      "1505",
      "1506",
      "1507",
      "1508",
      "1509",
      "1510",
      "1511",
      "1512",
      "1513",
      "1514",
      "1515",
      "1516",
      "1517",
      "1518",
      "1519",
      "1520",
      "1521",
      "1522",
      "1523",
      "1524",
      "1525",
      "1526",
      "1527",
      "1528",
      "1529",
      "1530",
      "1531",
      "1532",
      "1533",
      "1534",
      "1535",
      "1536",
      "1537",
      "1538",
      "1539",
      "1540",
      "1541",
      "1542",
      "1543",
      "1544",
      "1545",
      "1546",
      "1547",
      "1548",
      "1549",
      "1550",
      "1551",
      "1552",
      "1553",
      "1554",
      "1555",
      "1556",
      "1557",
      "1558",
      "1559",
      "1560",
      "1561",
      "1562",
      "1563",
      "1564",
      "1565",
      "1566",
      "1567",
      "1568",
      "1569",
      "1570",
      "1571",
      "1572",
      "1573",
      "1574",
      "1575",
      "1576",
      "1577",
      "1578",
      "1579",
      "1580",
      "1581",
      "1582",
      "1583",
      "1584",
      "1585",
      "1586",
      "1587",
      "1588",
      "1589",
      "1590",
      "1591",
      "1592",
      "1593",
      "1594",
      "1595",
      "1596",
      "1597",
      "1598",
      "1599",
      "1600",
      "1601",
      "1602",
      "1603",
      "1604",
      "1605",
      "1606",
      "1607",
      "1608",
      "1609",
      "1610",
      "1611",
      "1612",
      "1613",
      "1614",
      "1615",
      "1616",
      "1617",
      "1618",
      "1619",
      "1620",
      "1621",
      "1622",
      "1623",
      "1624",
      "1625",
      "1626",
      "1627",
      "1628",
      "1629",
      "1630",
      "1631",
      "1632",
      "1633",
      "1634",
      "1635",
      "1636",
      "1637",
      "1638",
      "1639",
      "1640",
      "1641",
      "1642",
      "1643",
      "1644",
      "1645",
      "1646",
      "1647",
      "1648",
      "1649",
      "1650",
      "1651",
      "1652",
      "1653",
      "1654",
      "1655",
      "1656",
      "1657",
      "1658",
      "1659",
      "1660",
      "1661",
      "1662",
      "1663",
      "1664",
      "1665",
      "1666",
      "1667",
      "1668",
      "1669",
      "1670",
      "1671",
      "1672",
      "1673",
      "1674",
      "1675",
      "1676",
      "1677",
      "1678",
      "1679",
      "1680",
      "1681",
      "1682",
      "1683",
      "1684",
      "1685",
      "1686",
      "1687",
      "1688",
      "1689",
      "1690",
      "1691",
      "1692",
      "1693",
      "1694",
      "1695",
      "1696",
      "1697",
      "1698",
      "1699",
      "1700",
      "1701",
      "1702",
      "1703",
      "1704",
      "1705",
      "1706",
      "1707",
      "1708",
      "1709",
      "1710",
      "1711",
      "1712",
      "1713",
      "1714",
      "1715",
      "1716",
      "1717",
      "1718",
      "1719",
      "1720",
      "1721",
      "1722",
      "1723",
      "1724",
      "1725",
      "1726",
      "1727",
      "1728",
      "1729",
      "1730",
      "1731",
      "1732",
      "1733",
      "1734",
      "1735",
      "1736",
      "1737",
      "1738",
      "1739",
      "1740",
      "1741",
      "1742",
      "1743",
      "1744",
      "1745",
      "1746",
      "1747",
      "1748",
      "1749",
      "1750",
      "1751",
      "1752",
      "1753",
      "1754",
      "1755",
      "1756",
      "1757",
      "1758",
      "1759",
      "1760",
      "1761",
      "1762",
      "1763",
      "1764",
      "1765",
      "1766",
      "1767",
      "1768",
      "1769",
      "1770",
      "1771",
      "1772",
      "1773",
      "1774",
      "1775",
      "1776",
      "1777",
      "1778",
      "1779",
      "1780",
      "1781",
      "1782",
      "1783",
      "1784",
      "1785",
      "1786",
      "1787",
      "1788",
      "1789",
      "1790",
      "1791",
      "1792",
      "1793",
      "1794",
      "1795",
      "1796",
      "1797",
      "1798",
      "1799",
      "1800",
      "1801",
      "1802",
      "1803",
      "1804",
      "1805",
      "1806",
      "1807",
      "1808",
      "1809",
      "1810",
      "1811",
      "1812",
      "1813",
      "1814",
      "1815",
      "1816",
      "1817",
      "1818",
      "1819",
      "1820",
      "1821",
      "1822",
      "1823",
      "1824",
      "1825",
      "1826",
      "1827",
      "1828",
      "1829",
      "1830",
      "1831",
      "1832",
      "1833",
      "1834",
      "1835",
      "1836",
      "1837",
      "1838",
      "1839",
      "1840",
      "1841",
      "1842",
      "1843",
      "1844",
      "1845",
      "1846",
      "1847",
      "1848",
      "1849",
      "1850",
      "1851",
      "1852",
      "1853",
      "1854",
      "1855",
      "1856",
      "1857",
      "1858",
      "1859",
      "1860",
      "1861",
      "1862",
      "1863",
      "1864",
      "1865",
      "1866",
      "1867",
      "1868",
      "1869",
      "1870",
      "1871",
      "1872",
      "1873",
      "1874",
      "1875",
      "1876",
      "1877",
      "1878",
      "1879",
      "1880",
      "1881",
      "1882",
      "1883",
      "1884",
      "1885",
      "1886",
      "1887",
      "1888",
      "1889",
      "1890",
      "1891",
      "1892",
      "1893",
      "1894",
      "1895",
      "1896",
      "1897",
      "1898",
      "1899",
      "1900",
      "1901",
      "1902",
      "1903",
      "1904",
      "1905",
      "1906",
      "1907",
      "1908",
      "1909",
      "1910",
      "1911",
      "1912",
      "1913",
      "1914",
      "1915",
      "1916",
      "1917",
      "1918",
      "1919",
      "1920",
      "1921",
      "1922",
      "1923",
      "1924",
      "1925",
      "1926",
      "1927",
      "1928",
      "1929",
      "1930",
      "1931",
      "1932",
      "1933",
      "1934",
      "1935",
      "1936",
      "1937",
      "1938",
      "1939",
      "1940",
      "1941",
      "1942",
      "1943",
      "1944",
      "1945",
      "1946",
      "1947",
      "1948",
      "1949",
      "1950",
      "1951",
      "1952",
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026",
      "2027",
      "2028",
      "2029",
      "2030",
      "2031",
      "2032",
      "2033",
      "2034",
      "2035",
      "2036",
      "2037",
      "2038",
      "2039",
      "2040",
      "2041",
      "2042",
      "2043",
      "2044",
      "2045",
      "2046",
      "2047",
      "2048",
      "2049",
      "2050",
      "2051",
      "2052",
      "2053",
      "2054",
      "2055",
      "2056",
      "2057",
      "2058",
      "2059",
      "2060",
      "2061",
      "2062",
      "2063",
      "2064",
      "2065",
      "2066",
      "2067",
      "2068",
      "2069",
      "2070",
      "2071",
      "2072",
      "2073",
      "2074",
      "2075",
      "2076",
      "2077",
      "2078",
      "2079",
      "2080",
      "2081",
      "2082",
      "2083",
      "2084",
      "2085",
      "2086",
      "2087",
      "2088",
      "2089",
      "2090",
      "2091",
      "2092",
      "2093",
      "2094",
      "2095",
      "2096",
      "2097",
      "2098",
      "2099",
      "2100",
      "2101",
      "2102",
      "2103",
      "2104",
      "2105",
      "2106",
      "2107",
      "2108",
      "2109",
      "2110",
      "2111",
      "2112",
      "2113",
      "2114",
      "2115",
      "2116",
      "2117",
      "2118",
      "2119",
      "2120",
      "2121",
      "2122",
      "2123",
      "2124",
      "2125",
      "2126",
      "2127",
      "2128",
      "2129",
      "2130",
      "2131",
      "2132",
      "2133",
      "2134",
      "2135",
      "2136",
      "2137",
      "2138",
      "2139",
      "2140",
      "2141",
      "2142",
      "2143",
      "2144",
      "2145",
      "2146",
      "2147",
      "2148",
      "2149",
      "2150",
      "2151",
      "2152",
      "2153",
      "2154",
      "2155",
      "2156",
      "2157",
      "2158",
      "2159",
      "2160",
      "2161",
      "2162",
      "2163",
      "2164",
      "2165",
      "2166",
      "2167",
      "2168",
      "2169",
      "2170",
      "2171",
      "2172",
      "2173",
      "2174",
      "2175",
      "2176",
      "2177",
      "2178",
      "2179",
      "2180",
      "2181",
      "2182",
      "2183",
      "2184",
      "2185",
      "2186",
      "2187",
      "2188",
      "2189",
      "2190",
      "2191",
      "2192",
      "2193",
      "2194",
      "2195",
      "2196",
      "2197",
      "2198",
      "2199",
      "2200",
      "2201",
      "2202",
      "2203",
      "2204",
      "2205",
      "2206",
      "2207",
      "2208",
      "2209",
      "2210",
      "2211",
      "2212",
      "2213",
      "2214",
      "2215",
      "2216",
      "2217",
      "2218",
      "2219",
      "2220",
      "2221",
      "2222",
      "2223",
      "2224",
      "2225",
      "2226",
      "2227",
      "2228",
      "2229",
      "2230",
      "2231",
      "2232",
      "2233",
      "2234",
      "2235",
      "2236",
      "2237",
      "2238",
      "2239",
      "2240",
      "2241",
      "2242",
      "2243",
      "2244",
      "2245",
      "2246",
      "2247",
      "2248",
      "2249",
      "2250",
      "2251",
      "2252",
      "2253",
      "2254",
      "2255",
      "2256",
      "2257",
      "2258",
      "2259",
      "2260",
      "2261",
      "2262",
      "2263",
      "2264",
      "2265",
      "2266",
      "2267",
      "2268",
      "2269",
      "2270",
      "2271",
      "2272",
      "2273",
      "2274",
      "2275",
      "2276",
      "2277",
      "2278",
      "2279",
      "2280",
      "2281",
      "2282",
      "2283",
      "2284",
      "2285",
      "2286",
      "2287",
      "2288",
      "2289",
      "2290",
      "2291",
      "2292",
      "2293",
      "2294",
      "2295",
      "2296",
      "2297",
      "2298",
      "2299",
      "2300",
      "2301",
      "2302",
      "2303",
      "2304",
      "2305",
      "2306",
      "2307",
      "2308",
      "2309",
      "2310",
      "2311",
      "2312",
      "2313",
      "2314",
      "2315",
      "2316",
      "2317",
      "2318",
      "2319",
      "2320",
      "2321",
      "2322",
      "2323",
      "2324",
      "2325",
      "2326",
      "2327",
      "2328",
      "2329",
      "2330",
      "2331",
      "2332",
      "2333",
      "2334",
      "2335",
      "2336",
      "2337",
      "2338",
      "2339",
      "2340",
      "2341",
      "2342",
      "2343",
      "2344",
      "2345",
      "2346",
      "2347",
      "2348",
      "2349",
      "2350",
      "2351",
      "2352",
      "2353",
      "2354",
      "2355",
      "2356",
      "2357",
      "2358",
      "2359",
      "2360",
      "2361",
      "2362",
      "2363",
      "2364",
      "2365",
      "2366",
      "2367",
      "2368",
      "2369",
      "2370",
      "2371",
      "2372",
      "2373",
      "2374",
      "2375",
      "2376",
      "2377",
      "2378",
      "2379",
      "2380",
      "2381",
      "2382",
      "2383",
      "2384",
      "2385",
      "2386",
      "2387",
      "2388",
      "2389",
      "2390",
      "2391",
      "2392",
      "2393",
      "2394",
      "2395",
      "2396",
      "2397",
      "2398",
      "2399",
      "2400",
      "2401",
      "2402",
      "2403",
      "2404",
      "2405",
      "2406",
      "2407",
      "2408",
      "2409",
      "2410",
      "2411",
      "2412",
      "2413",
      "2414",
      "2415",
      "2416",
      "2417",
      "2418",
      "2419",
      "2420",
      "2421",
      "2422",
      "2423",
      "2424",
      "2425",
      "2426",
      "2427",
      "2428",
      "2429",
      "2430",
      "2431",
      "2432",
      "2433",
      "2434",
      "2435",
      "2436",
      "2437",
      "2438",
      "2439",
      "2440",
      "2441",
      "2442",
      "2443",
      "2444",
      "2445",
      "2446",
      "2447",
      "2448",
      "2449",
      "2450",
      "2451",
      "2452",
      "2453",
      "2454",
      "2455",
      "2456",
      "2457",
      "2458",
      "2459",
      "2460",
      "2461",
      "2462",
      "2463",
      "2464",
      "2465",
      "2466",
      "2467",
      "2468",
      "2469",
      "2470",
      "2471",
      "2472",
      "2473",
      "2474",
      "2475",
      "2476",
      "2477",
      "2478",
      "2479",
      "2480",
      "2481",
      "2482",
      "2483",
      "2484",
      "2485",
      "2486",
      "2487",
      "2488",
      "2489",
      "2490",
      "2491",
      "2492",
      "2493",
      "2494",
      "2495",
      "2496",
      "2497",
      "2498",
      "2499",
      "2500"
    ]
  },
  {
    "sourceQuestionId": "89",
    "key": "business.yearsInPractice",
    "label": "Years in Practice",
    "stage": 3,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48",
      "49",
      "50+"
    ]
  },
  {
    "sourceQuestionId": "91",
    "key": "people.ownerDentistCount",
    "label": "Number of owner dentists",
    "stage": 2,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20"
    ]
  },
  {
    "sourceQuestionId": "92",
    "key": "people.dentistCount",
    "label": "Number of Dentists in the practice",
    "stage": 2,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20+"
    ]
  },
  {
    "sourceQuestionId": "93",
    "key": "people.hygienistCount",
    "label": "Number of Hygienists",
    "stage": 2,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48",
      "49",
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "56",
      "57",
      "58",
      "59",
      "60",
      "61",
      "62",
      "63",
      "64",
      "65",
      "66",
      "67",
      "68",
      "69",
      "70",
      "71",
      "72",
      "73",
      "74",
      "75",
      "76",
      "77",
      "78",
      "79",
      "80",
      "81",
      "82",
      "83",
      "84",
      "85",
      "86",
      "87",
      "88",
      "89",
      "90",
      "91",
      "92",
      "93",
      "94",
      "95",
      "96",
      "97",
      "98",
      "99",
      "100+"
    ]
  },
  {
    "sourceQuestionId": "94",
    "key": "operations.activePatientCount",
    "label": "Approximate active patient count",
    "stage": 2,
    "kind": "number",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "96",
    "key": "business.ownershipType",
    "label": "Type of ownership",
    "stage": 0,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "Independently Owned",
      "Group Owned",
      "Equity Owned",
      "ESOP"
    ]
  },
  {
    "sourceQuestionId": "97",
    "key": "business.facilityTenure",
    "label": "Do you own or lease you facility?",
    "stage": 3,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "Lease",
      "Own"
    ]
  },
  {
    "sourceQuestionId": "98",
    "key": "operations.reportedOpenDaysPerWeek",
    "label": "How many days in the week are you open?",
    "stage": 2,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7"
    ]
  },
  {
    "sourceQuestionId": "99",
    "key": "operations.practiceSoftware",
    "label": "What practice management software do you use?",
    "stage": 2,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "Dentrix",
      "Dentrix Ascend",
      "Dentrix Enterprise",
      "Easy Dental",
      "OMSVision",
      "Power Practice",
      "Dentally",
      "EXACT (Software of Excellence)",
      "Eaglesoft",
      "Fuse",
      "Open Dental",
      "Curve Dental",
      "Denticon",
      "CareStack",
      "tab32",
      "DentiMax Flow",
      "DentiMax",
      "Sensei Cloud",
      "SoftDent",
      "PracticeWorks",
      "CS R4+",
      "CS WinOMS",
      "CS WinOMS Cloud",
      "OrthoTrac",
      "Cloud 9 Ortho",
      "Dolphin Management",
      "Ortho2 Edge Cloud",
      "topsOrtho",
      "DSN Cloud",
      "OMS-Exec",
      "ABELDent",
      "ClearDent",
      "ClearDent Cloud",
      "Tracker",
      "MaxiDent",
      "XLDent",
      "XLDent Cloud",
      "iDentalSoft",
      "MOGO Cloud",
      "Oryx",
      "Archy",
      "DoveTail",
      "Dox Pedo / DOX",
      "Dentisoft",
      "Dentech",
      "ACE Dental",
      "Practice-Web",
      "MacPractice DDS",
      "QSIDental",
      "SuzyDental",
      "Dental 4 Windows (D4W)",
      "Dental4Web (D4W)",
      "Core Practice",
      "Oasis",
      "Titanium Dental",
      "MediRecords Dental",
      "Praktika",
      "AeronaDental",
      "Systems for Dentists (SfD)",
      "Pearl Dental Software",
      "iSmile",
      "DentalPlus",
      "DentSys",
      "Paragon",
      "Arthur",
      "Clockwork",
      "Shire Dental",
      "Status Point",
      "BestoSys",
      "Dentee",
      "DentalTap",
      "Clinicminds",
      "DentalEMR",
      "DentalVision",
      "Daisy",
      "Aspire",
      "Aspro",
      "Dental Plus"
    ]
  },
  {
    "sourceQuestionId": "100",
    "key": "operations.procedures",
    "label": "Which procedures do you currently provide? (Check all that apply)Type a question",
    "stage": 4,
    "kind": "multi",
    "required": true,
    "hidden": false,
    "options": [
      "General / Restorative",
      "Crowns & Bridges",
      "Implants",
      "Full-Arch Implant Restorations",
      "Removable Dentures",
      "Cosmetic Dentistry",
      "Dentures",
      "Veneers",
      "Clear Aligners",
      "Endodontics",
      "Oral surgery",
      "Other"
    ]
  },
  {
    "sourceQuestionId": "103",
    "key": "financial.processingFee",
    "label": "What do you get charged for your credit car processing fee?",
    "stage": 3,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      ".5%",
      ".75%",
      "1%",
      "1.25%",
      "1.5%",
      "1.75%",
      "2.0%",
      "2.25%",
      "2.50%",
      "2.75%",
      "3.0%",
      "3.25%",
      "3.5%",
      "3.75%",
      "4.0%",
      "4.25%",
      "4.5%",
      "4.75%",
      "WAY TOO MUCH!"
    ]
  },
  {
    "sourceQuestionId": "104",
    "key": "operations.intraoralScanner",
    "label": "Do you have an Intraoral scanner?",
    "stage": 2,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "I don't have an intraoral scanner",
      "I' looking for an intraoral scanner",
      "3Shape - TRIOS 6",
      "3Shape - TRIOS 5",
      "3Shape - TRIOS 3 Wired",
      "3Shape - TRIOS Core",
      "3Shape - TRIOS 4",
      "3Shape - TRIOS Standard / Color",
      "3Shape - PrograScan One+",
      "Align Tech -iTero Lumina",
      "Align Tech - iTero Lumina Pro",
      "Align Tech - iTero Element 5D Plus",
      "Align Tech - iTero Element 5D Plus Lite",
      "Align Tech - iTero Element 5D",
      "Align Tech - iTero Element Flex",
      "Align Tech - iTero Element 2 / 2 Plus",
      "Dentsply Sirona - Primescan 2",
      "Dentsply Sirona - Primescan",
      "Dentsply Sirona - CEREC Omnicam",
      "Medit - i900 Mobility",
      "Medit - i900 classic",
      "Medit - i900",
      "Medit - i700 wireless",
      "Medit - i700",
      "Medit - i600",
      "Medit - i500",
      "Dexis - IS 3800W",
      "Dexis -IS 3800",
      "Dexis - IS 3700",
      "Dexis - IS 3600",
      "Planmeca - Emerald S",
      "Planmeca - Emerald",
      "Planmeca - PlanScan",
      "Shining 3D - Aoralscan Elite Wireless",
      "Shining 3D - Aoralscan Elite",
      "Shining 3D - Aoralscan 3 Wireless (3W)",
      "Shining 3D - Aoralscan 3",
      "Shining 3D - Aoralscan L",
      "Shining 3D - Aoralscan Elf",
      "Shining 3D - Aoralscan 2",
      "Allied Star (Straumann) - Sensa",
      "Allied Star (Straumann) - AS 260",
      "Allied Star (Straumann) - AS 200E",
      "Allied Star (Straumann) - AS 100",
      "Straumann - SIRIOS X3",
      "Straumann - SIRIOS",
      "Straumann - Virtuo Vivo",
      "Neoss - NeoScan 2000",
      "Neoss - NeoScan 1000",
      "3DISC - OVO3",
      "3DISC - OVO",
      "3DISC - Heron IOS",
      "Launca - DL-300 Wireless",
      "Launca - DL-300",
      "Launca - DL-300P",
      "Launca - DL-206",
      "Launca - DL-206P",
      "PANDA Smart",
      "PANDA P4",
      "PANDA P3",
      "PANDA P2 Plus",
      "PANDA P2",
      "BLZ Dental - Leap 500 Wireless",
      "BLZ Dental - INO200",
      "IBLZ Dental - NO100 Plus",
      "BLZ Dental - INO100",
      "Fussen - S6500",
      "Fussen - S6000",
      "Fussen - S10",
      "Runyes - 3DS MEGA (V5)",
      "Runyes - 3DS ULTRA (V6)",
      "Aidite - Rapid 5",
      "Aidite - Rapid 3",
      "Aidite - Infinity 5",
      "Aidite - Infinity 4",
      "Aidite - Elegant 3",
      "Eighteeth / Sifary - Helios 700",
      "Eighteeth / Sifary - Helios 680",
      "Eighteeth / Sifary - Helios 600",
      "Eighteeth / Sifary - Helios 500",
      "Ivoclar - VivaScan",
      "NewTom (Cefla) - NewTomIOS",
      "NewTom (Cefla) - ViSIOScan WL",
      "NewTom (Cefla) - ViSIOScan WR",
      "Huvitz - OCTiX IntraOral Scanner (LSO-100)",
      "Huvitz - Lilivis (LS-100)"
    ]
  },
  {
    "sourceQuestionId": "105",
    "key": "interests.acquisitionIntent",
    "label": "Do you anticipate acquiring another practice?",
    "stage": 3,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "Yes",
      "No"
    ]
  },
  {
    "sourceQuestionId": "106",
    "key": "interests.transitionIntent",
    "label": "Are you considering selling or transitioning your practice within the next 5–10 years?",
    "stage": 3,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "Yes",
      "No",
      "Maybe"
    ]
  },
  {
    "sourceQuestionId": "107",
    "key": "financial.practiceRevenue",
    "label": "What was the practice revenue last year?",
    "stage": 3,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "Under $500K",
      "$501K - $750",
      "$751K - $1M",
      "$1.1M - $1.25M",
      "$1.26M - $1.5M",
      "$1.51M - $1.75",
      "$1.76M - $2M",
      "$2.1M - $2.25M",
      "$2.26M - $2.5M",
      "$2.51M - $2.75M",
      "$2.76M - $3M",
      "$3.1M - $3.25M",
      "$3.26M - $3.5M",
      "$3.51M - $3.75M",
      "$3.76M - $4M",
      "$4.1M - $4.25M",
      "$4.26M - $4.5M",
      "$4.51M - $4.75M",
      "$4.76M - $5.0M",
      "$5.1M - $5.25M",
      "$5.26M - $5.5M",
      "$5.51M - $5.75M",
      "$5.76M - $6.0M",
      "$6.1M - $6.25M",
      "$6.26M - $6.5M",
      "$6.51M - $6.75M",
      "$6.76M - $7.0M",
      "$7.1M - $7.25M",
      "$7.26M - $7.5M",
      "$7.51M - $7.75M",
      "$7.76M - $8M",
      "$8.1M - $8.25M",
      "$8.26M - $8.5M",
      "$8.51M - $8.75M",
      "$8.76M - $9M",
      "$9.1M - $9.25M",
      "$9.26M - $9.5M",
      "$9.51M - $9.75M",
      "$9.76M - $10.0M",
      "$10M or more"
    ]
  },
  {
    "sourceQuestionId": "108",
    "key": "financial.annualCardVolume",
    "label": "Approximate annual credit card volume?",
    "stage": 3,
    "kind": "select",
    "required": true,
    "hidden": false,
    "options": [
      "$10K to $20K",
      "$21K to $30K",
      "$31K to $40K",
      "$41K to $50K",
      "$51K to $60K",
      "$61K to $70K",
      "$71K to $80K",
      "$81K to $90K",
      "$91K to $100K",
      "$101K to $110K",
      "$111K to $120K",
      "$121K to $130K",
      "$131K to $140K",
      "$141K to $150K",
      "$151K to $160K",
      "$161K to $170K",
      "$171K to $180K",
      "$181K to $190K",
      "$191K to $200K",
      "$201K to $210K",
      "$211K to $220K",
      "$221K to $230K",
      "$231K to $240K",
      "$241K to $250K",
      "$251K to $260K",
      "$261K to $270K",
      "$271K to $280K",
      "$281K to $290K",
      "$291K to $300K",
      "$301K to $310K",
      "$311K to $320K",
      "$321K to $330K",
      "$331K to $340K",
      "$341K to $350K",
      "$351K to $360K",
      "$361K to $370K",
      "$371K to $380K",
      "$381K to $390K",
      "$391K to $400K",
      "$401K to $410K",
      "$411K to $420K",
      "$421K to $430K",
      "$431K to $440K",
      "$441K to $450K",
      "$451K to $460K",
      "$461K to $470K",
      "$471K to $480K",
      "$481K to $490K",
      "$491K to $500K",
      "$501K to $510K",
      "$511K to $520K",
      "$521K to $530K",
      "$531K to $540K",
      "$541K to $550K",
      "$551K to $560K",
      "$561K to $570K",
      "$571K to $580K",
      "$581K to $590K",
      "$591K to $600K",
      "$601K to $610K",
      "$611K to $620K",
      "$621K to $630K",
      "$631K to $640K",
      "$641K to $650K",
      "$651K to $660K",
      "$661K to $670K",
      "$671K to $680K",
      "$681K to $690K",
      "$691K to $700K",
      "$701K to $710K",
      "$711K to $720K",
      "$721K to $730K",
      "$731K to $740K",
      "$741K to $750K",
      "$751K to $760K",
      "$761K to $770K",
      "$771K to $780K",
      "$781K to $790K",
      "$791K to $800K",
      "$801K to $810K",
      "$811K to $820K",
      "$821K to $830K",
      "$831K to $840K",
      "$841K to $850K",
      "$851K to $860K",
      "$861K to $870K",
      "$871K to $880K",
      "$881K to $890K",
      "$891K to $900K",
      "$901K to $910K",
      "$911K to $920K",
      "$921K to $930K",
      "$931K to $940K",
      "$941K to $950K",
      "$951K to $960K",
      "$961K to $970K",
      "$971K to $980K",
      "$981K to $990K",
      "$991K to $1M",
      "$1M or more"
    ]
  },
  {
    "sourceQuestionId": "110",
    "key": "business.npi",
    "label": "NPI Number",
    "stage": 3,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "112",
    "key": "business.practiceName",
    "label": "Doing Business As / Practice Name",
    "stage": 0,
    "kind": "text",
    "required": false,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "113",
    "key": "operations.operatories",
    "label": "Number of operatories",
    "stage": 2,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "118",
    "key": "people.jobTitle",
    "label": "Job Title",
    "stage": 1,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "129",
    "key": "operations.daysOpen",
    "label": "What days of the week are you open",
    "stage": 2,
    "kind": "multi",
    "required": true,
    "hidden": false,
    "options": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ]
  },
  {
    "sourceQuestionId": "132",
    "key": "operations.typicalHours",
    "label": "What are your typical hours of operation",
    "stage": 2,
    "kind": "text",
    "required": true,
    "hidden": false,
    "options": []
  },
  {
    "sourceQuestionId": "133",
    "key": "operations.insuranceCarriers",
    "label": "Please check all the insurance companies you accept",
    "stage": 4,
    "kind": "multi",
    "required": true,
    "hidden": false,
    "options": [
      "Delta Dental",
      "Cigna Dental",
      "Aetna Dental",
      "MetLife Dental",
      "United Healthcare Dental",
      "Guardian Dental",
      "United Concordia Dental",
      "Blue Cross Blue Shield Dental",
      "Humana Dental",
      "Ameritas Dental",
      "Principal Dental",
      "Sun Life Dental / DentaQuest",
      "Anthem / Elevance Dental",
      "Lincoln Financial Dental",
      "GEHA Dental",
      "LIBERTY Dental Plan",
      "Renaissance Dental",
      "Mutual of Omaha Dental",
      "MCNA Dental",
      "Physicians Mutual Dental",
      "Other"
    ]
  },
  {
    "sourceQuestionId": "134",
    "key": "business.website",
    "label": "website address",
    "stage": 3,
    "kind": "text",
    "required": false,
    "hidden": false,
    "options": []
  }
]
